// extracted by mini-css-extract-plugin
var _1 = "ra-artist-profile-art-section";
var _2 = "ra-artist-profile-news-wrapper";
var _3 = "ra-artist-profile-studio-wrapper";
var _4 = "ra-artist-secondary-banner";
export { _1 as "artistProfileArtSectionCls", _2 as "artistProfileNewsWrapperCls", _3 as "artistProfileStudioWrapperCls", _4 as "artistSecondaryBannerCls" }
